export default {
  // 查询企业详情
  getCompany: {
    method: 'get',
    url: '/api/getCompany'
  },
  // 编辑企业
  updateCompany: {
    method: 'put',
    url: '/api/updateCompany'
  }
}
